var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _g2, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _g3, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _circle, _circle2, _path90, _path91, _path92, _path93, _path94, _g4, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _g5, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _rect, _g6, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _g7, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _g8, _path134, _path135, _path136, _path137, _g9, _path138, _g10, _path139, _g11, _path140, _path141, _path142, _path143, _path144, _g12, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _g13, _path217, _path218, _path219, _path220, _path221, _path222;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-arrow-down",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 13.2l-5.4 5.3V3h-1v15.5l-5.4-5.3-.7.7 6.6 6.5 6.6-6.5zM12 19z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-arrow-down-circle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 13.2l.7.7-4.3 4.3-4.3-4.3.7-.7 3.1 3.1V7h1v9.2zM22 12A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-arrow-down-triangle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 12h5.6a1 1 0 01.7 1.7L12 17.3l-3.5-3.6a1 1 0 01.7-1.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-arrow-left",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.5H5.5l5.3-5.4-.7-.7L3.6 12l6.5 6.6.7-.7-5.3-5.4H21zM5 12z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-arrow-left-circle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 11.5H17v1H7.8l3 3.1-.7.7L5.8 12l4.3-4.3.7.7zM22 12A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-arrow-left-triangle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.2v5.6a1 1 0 01-1.7.7L6.8 12l3.5-3.5a1 1 0 011.7.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-arrow-right",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 5.4l-.7.7 5.3 5.4H3v1h15.5l-5.3 5.4.7.7 6.6-6.6zM19 12z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-arrow-right-circle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 7.7l4.3 4.3-4.3 4.3-.7-.7 3.1-3.1H7v-1h9.2l-3-3.1zM22 12A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-arrow-right-triangle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.8V9.2a1 1 0 011.7-.7l3.5 3.5-3.5 3.5a1 1 0 01-1.7-.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-arrow-up",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 10.1L12 3.5l-6.6 6.6.7.7 5.4-5.3V21h1V5.5l5.4 5.3zM12 5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-arrow-up-circle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.8l4.3 4.3-.7.7-3.1-3.1V17h-1V7.8l-3.1 3-.7-.7zM22 12A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-arrow-up-triangle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 12H9.2a1 1 0 01-.7-1.7L12 6.8l3.5 3.5a1 1 0 01-.7 1.7z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-ban",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM5.2 17.6C3.8 16 3.1 14 3.1 11.9s.7-4.1 2.1-5.7l12.7 12.7C14 22 8.3 21.4 5.2 17.6zm13.4.5L5.9 5.4c3.7-3.3 9.4-3 12.7.7 3.1 3.4 3.1 8.6 0 12z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-behance",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83 5.75a8 8 0 011.6.15 3.38 3.38 0 011.24.51c.345.233.62.554.8.93.202.456.298.952.28 1.45a2.68 2.68 0 01-.42 1.54 3.05 3.05 0 01-1.25 1 2.92 2.92 0 011.68 1.15c.393.59.59 1.29.56 2a3.39 3.39 0 01-.32 1.59 3.08 3.08 0 01-1 1.11 4.27 4.27 0 01-1.4.64A6 6 0 018 18H2V5.75h5.83zm-.35 5a2 2 0 001.19-.35c.328-.27.5-.687.46-1.11A1.47 1.47 0 009 8.54a1.16 1.16 0 00-.42-.43A1.8 1.8 0 008 7.9a3.26 3.26 0 00-.7-.06H4.74v2.87l2.74.04zm.15 5.22c.252.003.503-.02.75-.07a2 2 0 00.62-.3 1.39 1.39 0 00.44-.49 1.73 1.73 0 00.16-.8A1.64 1.64 0 009.09 13a2.33 2.33 0 00-1.41-.4H4.74v3.38l2.89-.01zm8.54-.08a2.18 2.18 0 001.58.54 2.24 2.24 0 001.25-.37 1.6 1.6 0 00.65-.79h2.15a4.06 4.06 0 01-1.58 2.29 4.64 4.64 0 01-2.58.69 5.23 5.23 0 01-1.9-.33 4 4 0 01-2.33-2.44 5.25 5.25 0 01-.32-1.89 5.12 5.12 0 01.33-1.86 4.14 4.14 0 01.93-1.49 4.48 4.48 0 011.44-1 4.59 4.59 0 011.85-.36 4.31 4.31 0 012 .44A4 4 0 0121 10.5c.37.505.636 1.08.78 1.69a6.18 6.18 0 01.17 2h-6.38a2.5 2.5 0 00.6 1.7zM19 11.22a1.83 1.83 0 00-1.38-.49 2 2 0 00-1 .2 1.8 1.8 0 00-.62.49 1.62 1.62 0 00-.33.62 2.87 2.87 0 00-.11.59h4a2.4 2.4 0 00-.56-1.41zm-3.93-4.65h4.98v1.21h-4.98V6.57z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-bookmark",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22.7l-6-6-6 6V2h12v20.7zm-6-7.4l5 5V3H7v17.3l5-5z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-box",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M21 2H3v4h1v16h16V6h1V2zm-2 19H5V6h14v15zm1-16H4V3h16v2z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8h8v1H8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-burger",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5v1H2V5zM2 12.5h20v-1H2zM2 19h20v-1H2z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-calendar",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 4H17V3h-1v1H8V3H7v1H3.5A1.5 1.5 0 002 5.5v13A1.5 1.5 0 003.5 20h17a1.5 1.5 0 001.5-1.5v-13A1.5 1.5 0 0020.5 4zm.5 14.5a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-13a.5.5 0 01.5-.5H7v1h1V5h8v1h1V5h3.5a.5.5 0 01.5.5zM4 8h16v1H4z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-camera",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 20h-17A1.5 1.5 0 012 18.5v-10A1.5 1.5 0 013.5 7h4.3l1.5-2.3a1.5 1.5 0 011.2-.7h3a1.5 1.5 0 011.2.7L16.2 7h4.3A1.5 1.5 0 0122 8.5v10a1.5 1.5 0 01-1.5 1.5zM3.5 8a.5.5 0 00-.5.5v10a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-10a.5.5 0 00-.5-.5h-4.8l-1.8-2.8-.4-.2h-3l-.4.2L8.3 8zM12 18a5 5 0 115-5 5 5 0 01-5 5zm0-9a4 4 0 104 4 4 4 0 00-4-4zM7 5H4v1h3z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-card",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 5h-17A1.5 1.5 0 002 6.5v11A1.5 1.5 0 003.5 19h17a1.5 1.5 0 001.5-1.5v-11A1.5 1.5 0 0020.5 5zM3 9h18v3H3zm18 8.5a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5V13h18zM3 8V6.5a.5.5 0 01.5-.5h17a.5.5 0 01.5.5V8zm5 7H4v-1h4z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-chart-line",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20v1H3V3h1v17z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.2l2.5 2.5 6-6v3.8h1V4h-5.5v1h3.8L13 10.3l-2.5-2.5-4.3 4.3.6.8z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-check",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 16.9L4 11.4l.8-.7 4.8 4.8 8.5-8.4.7.7z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-check-circle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 7.9l.7.7-7.8 7.6-4.7-4.6.7-.7 4 3.9zM22 12A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-chevron-left",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 17.2L9 11.6 14.6 6l.8.7-4.9 4.9 4.9 4.9z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-chevron-right",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8 17.2l-.8-.7 4.9-4.9L9 6.7l.8-.7 5.6 5.6z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-clip",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M11 22a2.9 2.9 0 01-3-3V6a4 4 0 018 0v10h-1V6a3 3 0 00-6 0v13a2 2 0 004 0V8a1 1 0 00-2 0v8h-1V8a2 2 0 014 0v11a2.9 2.9 0 01-3 3z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-clock",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5h1v7.5H7v-1h4.5zM22 12A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-close",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7 12l3.7 3.6-.8.8-3.6-3.7-3.6 3.7-.8-.8 3.7-3.6-3.7-3.6.8-.8 3.6 3.7 3.6-3.7.8.8z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-close-big",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7 12l6.7 6.6-.8.8-6.6-6.7-6.6 6.7-.8-.8 6.7-6.6-6.7-6.6.8-.8 6.6 6.7 6.6-6.7.8.8z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-close-circle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 8.3L12.6 12l3.7 3.6-.7.7-3.7-3.6-3.6 3.6-.7-.7 3.6-3.6-3.6-3.7.7-.7 3.6 3.7 3.7-3.7zM22 12A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-code-circle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12l-2.9 2.9-.7-.8 2.1-2.1-2.1-2.1.7-.8zM7.9 9.1L5 12l2.9 2.9.7-.8L6.5 12l2.1-2.1zM22 12A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9zM9.6 16.5l1 .3 3.7-9.3-.9-.3z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-collapse",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.4l-4.9-4.9-4.9 4.9-.7-.8L11.6 9l5.6 5.6z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-comment",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H5a2 2 0 00-2 2v10a2 2 0 002 2h2v5.4l1.7-1.7 3.7-3.7H19a2 2 0 002-2V5a2 2 0 00-2-2zm1 12a.9.9 0 01-1 1h-7l-4 4v-4H5a.9.9 0 01-1-1V5a.9.9 0 011-1h14a.9.9 0 011 1zM9 10a.9.9 0 01-1 1 .9.9 0 01-1-1 .9.9 0 011-1 .9.9 0 011 1zm4 0a1 1 0 01-2 0 1 1 0 012 0zm4 0a1 1 0 01-2 0 1 1 0 012 0z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-copy",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4H18v-.6A1.5 1.5 0 0016.5 2h-11A1.5 1.5 0 004 3.4v15.2A1.5 1.5 0 005.5 20H7v.6A1.5 1.5 0 008.5 22h11a1.5 1.5 0 001.5-1.4V5.4A1.5 1.5 0 0019.5 4zM5 18.6V3.4a.5.5 0 01.5-.4h11a.5.5 0 01.5.4v15.2a.5.5 0 01-.5.4h-11a.5.5 0 01-.5-.4zm15 2a.5.5 0 01-.5.4h-11a.5.5 0 01-.5-.4V20h8.5a1.5 1.5 0 001.5-1.4V5h1.5a.5.5 0 01.5.4z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-delete",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4v-.5c0-.8-.7-1.5-1.5-1.5h-4c-.8 0-1.5.7-1.5 1.5V4H3v1h2v15.5c0 .8.7 1.5 1.5 1.5h11c.8 0 1.5-.7 1.5-1.5V5h2V4h-5.5zm-6-.5c0-.3.2-.5.5-.5h4c.3 0 .5.2.5.5V4h-5v-.5zm8.5 17c0 .3-.2.5-.5.5h-11c-.3 0-.5-.2-.5-.5V5h12v15.5z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8h1v10h-1zM8 8h1v10H8zM15 8h1v10h-1z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-designers-italia",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 20.2v-13h3.6v13.1l-3.6-.1zM23 10.1h-3.3v6.5c0 .2.1.4.3.6s.4.2.8.2h2.1l.2 2.8c-1.2.3-2.1.4-2.8.4-1.6 0-2.7-.3-3.3-1.1-.6-.7-.9-2-.9-3.9v-12h3.6v3.6H23v2.9zm-19.8 1c-.6 0-1.2-.2-1.6-.6-.4-.4-.6-.9-.6-1.5s.2-1.1.6-1.5c.4-.5.9-.7 1.6-.7s1.1.2 1.5.6c.4.5.6 1 .6 1.6s-.2 1.1-.6 1.5c-.4.4-.9.6-1.5.6z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-download",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.2L7.7 9.9l.7-.7 3.1 3.1V3h1v9.2l3.1-3 .7.7zm7-2.2v7.5a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5V12H4v7.5A1.5 1.5 0 005.5 21h13a1.5 1.5 0 001.5-1.5V12z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-error",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.2V5.7h1.2v8.5zm-.1 4.1h1.2v-1.8h-1.2zM22 7.9v8.3L16.1 22H7.9L2 16.2V7.9L7.9 2h8.2zm-1 .4L15.7 3H8.3L3 8.3v7.5L8.3 21h7.4l5.3-5.2z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-exchange-circle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 19a9 9 0 119-9 9 9 0 01-9 9zm5.1-8.9l.8.8-4.3 4.3a1.5 1.5 0 01-1.1.4 1.5 1.5 0 01-1.1-.4L9 14.7V17H8v-4h4v1H9.7l2.4 2.5h.8zm-6-4.6l-4.2 4.4-.8-.8 4.3-4.3a1.5 1.5 0 011.1-.4 1.5 1.5 0 011.1.4L15 9.3V7h1v4h-4v-1h2.3l-2.4-2.5h-.8z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-expand",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 15.4L6 9.8l.7-.8 4.9 4.9L16.5 9l.7.8z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-external-link",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M21 3v6h-1V4.7l-7.6 7.7-.8-.8L19.3 4H15V3zm-4 16.5a.5.5 0 01-.5.5h-12a.5.5 0 01-.5-.5v-12a.5.5 0 01.5-.5H12V6H4.5A1.5 1.5 0 003 7.5v12A1.5 1.5 0 004.5 21h12a1.5 1.5 0 001.5-1.5V12h-1z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-facebook",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M13.55 22v-9.11h3.07l.46-3.56h-3.53V7.05c0-1 .29-1.73 1.77-1.73h1.87V2.14A25.14 25.14 0 0014.45 2c-2.72 0-4.58 1.66-4.58 4.7v2.62H6.81v3.57h3.06V22h3.68z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-facebook-square",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M20 3H4a1 1 0 00-1 1v16a1 1 0 001 1h8.63v-6.95h-2.37v-2.74h2.34v-2a3.28 3.28 0 013.5-3.6c.705 0 1.41.04 2.11.12v2.44h-1.44c-1.13 0-1.34.53-1.34 1.32v1.74h2.7l-.35 2.72h-2.35v7H20a1 1 0 001-1V4a1 1 0 00-1-1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-file",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 2H6.5A1.5 1.5 0 005 3.5v17A1.5 1.5 0 006.5 22h11a1.5 1.5 0 001.5-1.5V6.3zm.3 1.7L17.3 6h-1.8a.5.5 0 01-.5-.5zM17.5 21h-11a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5H14v2.5A1.5 1.5 0 0015.5 7H18v13.5a.5.5 0 01-.5.5zM8 9h8v1H8zm0 2h8v1H8zm0 2h4v1H8z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-files",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7 2H7.5A1.5 1.5 0 006 3.5V4h-.5A1.5 1.5 0 004 5.5v15A1.5 1.5 0 005.5 22h11a1.5 1.5 0 001.5-1.5V20h.5a1.5 1.5 0 001.5-1.5V6.3zm.3 1.7L18.3 6h-1.8a.5.5 0 01-.5-.5zm1 16.8a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5H6v13.5A1.5 1.5 0 007.5 20H17zm1.5-1.5h-11a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5H15v2.5A1.5 1.5 0 0016.5 7H19v11.5a.5.5 0 01-.5.5zM9 9h8v1H9zm0 2h8v1H9zm0 2h4v1H9z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-flag",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 8l3.3-5H5V2H4v20h1v-9h15.4l-3.3-5zM5 4h13.6l-2.7 4 2.7 4H5V4z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-flickr",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.73,
    cy: 12,
    r: 4.73
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.27,
    cy: 12,
    r: 4.73
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-flickr-square",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4a3.26 3.26 0 00-2.38-1H6.38A3.26 3.26 0 004 4a3.26 3.26 0 00-1 2.37v11.25A3.26 3.26 0 004 20a3.26 3.26 0 002.39 1h11.24A3.38 3.38 0 0021 17.62V6.37A3.26 3.26 0 0020 4zm-9.56 9.77a2.5 2.5 0 01-3.51 0 2.49 2.49 0 010-3.52 2.5 2.5 0 013.51 0 2.49 2.49 0 010 3.52zm6.61 0A2.49 2.49 0 0112.82 12a2.49 2.49 0 014.24-1.76 2.49 2.49 0 010 3.52l-.01.01z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-folder",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6h-8l-2-2H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V8a2 2 0 00-2-2zm1 12a.9.9 0 01-1 1H4a.9.9 0 01-1-1V6a.9.9 0 011-1h5.6l1.7 1.7.3.3H20a.9.9 0 011 1zM4 8h16v1H4z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-fullscreen",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20h4.5v1H3v-5.5h1zM3 8.5h1V4h4.5V3H3zM20 20h-4.5v1H21v-5.5h-1zM15.5 3v1H20v4.5h1V3z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-funnel",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22h-1v-8.65L20.05 3H4l7 10.35V22h-1v-8.35L2.05 2H22l-8 11.65z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-github",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 00-3.16 19.49c.5.09.68-.22.68-.48v-1.7C6.73 19.91 6.14 18 6.14 18A2.69 2.69 0 005 16.5c-.91-.62.07-.61.07-.61a2.13 2.13 0 011.53 1 2.14 2.14 0 002.91.83 2.16 2.16 0 01.63-1.34c-2.14-.21-4.52-1.07-4.52-4.9a3.89 3.89 0 011-2.69 3.57 3.57 0 01.1-2.64s.84-.27 2.75 1a9.63 9.63 0 015 0c1.91-1.29 2.75-1 2.75-1 .37.835.405 1.78.1 2.64a3.89 3.89 0 011 2.69c0 3.84-2.34 4.68-4.57 4.93.482.49.73 1.164.68 1.85v2.75c0 .33.18.58.69.48A10 10 0 0012 2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-hearing",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9a6.8 6.8 0 01-3.5 6l-2 1.1a3.3 3.3 0 00-1.5 2.7A3.2 3.2 0 019.8 22h-.6a3.4 3.4 0 01-3-2.1l.9-.5A2.3 2.3 0 009.2 21h.6a2.1 2.1 0 001.6-.7 2 2 0 00.6-1.5 4 4 0 012-3.5l2-1.2A5.9 5.9 0 0019 9a6 6 0 00-6-6 6 6 0 00-4.8 2.4l-.8-.6A7 7 0 0113 2a7 7 0 017 7zM7.5 12A5.5 5.5 0 002 6.5v1a4.5 4.5 0 010 9v1A5.5 5.5 0 007.5 12zM5 12a2.9 2.9 0 00-3-3v1a2 2 0 010 4v1a2.9 2.9 0 003-3zm5 0a8 8 0 00-8-8v1a7 7 0 010 14v1a8 8 0 008-8zm5.9.3a4.5 4.5 0 001.2-3.2 4.5 4.5 0 00-1.2-3.2 4.5 4.5 0 00-3.2-1.4A4.8 4.8 0 009.5 6l-.3.3.2.3a8.8 8.8 0 011.3 3v.4h.4a1.5 1.5 0 010 3v1a2.5 2.5 0 002.5-2.5 2.6 2.6 0 00-2-2.5 8.5 8.5 0 00-1.1-2.6 3.9 3.9 0 012.2-.9 3.5 3.5 0 012.4 1 3.5 3.5 0 011 2.6 3.5 3.5 0 01-1 2.6z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-help",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 22h-1.4v-2.1h1.4zm-.1-4.9h-1.2a9.7 9.7 0 01-.1-1.7 2.7 2.7 0 01.3-1.2 5.6 5.6 0 01.7-1.3l2.3-2.1a9.6 9.6 0 001.8-2.1 4.5 4.5 0 00.5-2.3 3 3 0 00-1.1-2.6 6.2 6.2 0 00-3.4-.7 22.9 22.9 0 00-3.6.5l-1 .3-.2-1.2h.1a18.1 18.1 0 014.7-.8 7.4 7.4 0 014.3 1 4.2 4.2 0 011.4 3.5 5 5 0 01-.5 2.7 8.6 8.6 0 01-1.9 2.2 19.7 19.7 0 00-1.8 1.6 6.2 6.2 0 00-.9 1.2 2.3 2.3 0 00-.4 1.4z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-help-circle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 19a9 9 0 119-9 9 9 0 01-9 9zm-1.2-4.5H12v1.8h-1.2zm4.5-8a4.2 4.2 0 01-.3 1.8 5.4 5.4 0 01-1.3 1.4L12.3 13a2.8 2.8 0 00-.4 1.2v.6H11a3 3 0 01-.2-1 2.1 2.1 0 01.5-1.2 9 9 0 011.4-1.4 6.4 6.4 0 001.2-1.3 2.6 2.6 0 00.3-1.4 1.7 1.7 0 00-.6-1.4 3.5 3.5 0 00-2-.4L9.3 7h-.5v-.8a10.2 10.2 0 013-.5 4.9 4.9 0 012.7.6 2.7 2.7 0 01.8 2.2z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-horn",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9a3 3 0 000 6h.5L7 19.3A2.5 2.5 0 009.3 21h.2a1.4 1.4 0 001.2-.6 1.4 1.4 0 00.2-1.4l-1.3-4h1.8l8.6 3.8V4.7L11.4 9zm5 10.3a.7.7 0 01-.1.5l-.4.2h-.2a1.5 1.5 0 01-1.4-1l-1.3-4h1.9zM5 14a2 2 0 010-4h6v4zm14 3.2l-7-3V9.8l7-3.5zM22 9v6h-1V9z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-inbox",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2v14h3.7l1 2h6.6l1-2H20V2H4zm15 13h-3.3l-1 2H9.3l-1-2H5V3h14v12z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17h1v5H4v-5h1v4h14zM7 5h10v1H7zM7 8h10v1H7zM7 11h10v1H7z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-info-circle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 19a9 9 0 119-9 9 9 0 01-9 9zm-.7-15h1.5v2h-1.5zm0 3h1.5v9h-1.5z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-instagram",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.62l-.01.08H8.35a5.12 5.12 0 00-1.67.31c-.38.15-.72.382-1 .68-.298.28-.53.62-.68 1a5.12 5.12 0 00-.3 1.68v7.28c.01.57.114 1.134.31 1.67.15.38.382.72.68 1 .28.298.62.53 1 .68.536.196 1.1.3 1.67.31.95.05 1.24.05 3.64.05 2.4 0 2.64-.05 3.64-.05a5.12 5.12 0 001.67-.31A3.08 3.08 0 0019 17.31a5.12 5.12 0 00.3-1.68c.05-.95.05-1.24.05-3.64 0-2.4-.05-2.64-.05-3.64a5.12 5.12 0 00-.31-1.67 2.77 2.77 0 00-.68-1 2.77 2.77 0 00-1-.68 5.12 5.12 0 00-1.67-.38H12zM12 3v.05h3.71a6.9 6.9 0 012.19.42 4.64 4.64 0 012.68 2.63A6.9 6.9 0 0121 8.29c0 .96.05 1.27.05 3.71S21 14.71 21 15.71a6.9 6.9 0 01-.47 2.24 4.64 4.64 0 01-2.63 2.63 6.9 6.9 0 01-2.19.42c-.96.05-1.27.05-3.71.05S9.29 21 8.29 21a6.9 6.9 0 01-2.19-.47 4.64 4.64 0 01-2.63-2.63 6.9 6.9 0 01-.42-2.19V12 8.29a6.9 6.9 0 01.42-2.19A4.64 4.64 0 016.1 3.42 6.9 6.9 0 018.29 3H12zm0 4.38a4.62 4.62 0 110 9.24 4.62 4.62 0 010-9.24zM12 15a3 3 0 100-6 3 3 0 000 6zm4.8-6.72a1.08 1.08 0 110-2.16 1.08 1.08 0 010 2.16z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-key",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10a2 2 0 102 2 2 2 0 00-2-2zm0 3a1 1 0 111-1 .9.9 0 01-1 1zm-1-6a5.1 5.1 0 00-4.6 3H3.3l-2 2 3 3H7v-1h.3l1 1H11v-1h1.4a5.1 5.1 0 004.6 3 5 5 0 000-10zm0 9a4.1 4.1 0 01-3.8-2.7V13H10v1H8.7l-1-1H6v1H4.7l-2-2 1-1h9.4v-.3A4.1 4.1 0 0117 8a4 4 0 010 8z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-less-circle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3a9 9 0 016.36 15.36A9 9 0 015.64 5.62 8.93 8.93 0 0112 3m0-1a10 10 0 107.07 2.93A9.93 9.93 0 0012 2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11.25,
    width: 10,
    height: 1.5,
    rx: 0.75
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-link",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 13.4l-.7-.7a2.9 2.9 0 00.9-2.1 2.7 2.7 0 00-.9-2.1L9.2 4.9a3.2 3.2 0 00-4.3 0 3.2 3.2 0 000 4.3L7.8 12l-.7.7-2.9-2.8a4.2 4.2 0 010-5.7 4.2 4.2 0 015.7 0l3.5 3.6a3.6 3.6 0 011.2 2.8 3.6 3.6 0 01-1.2 2.8zm6.4 6.4a4.2 4.2 0 000-5.7l-2.9-2.8-.7.7 2.9 2.8a3.2 3.2 0 010 4.3 3.2 3.2 0 01-4.3 0l-3.5-3.6a2.7 2.7 0 01-.9-2.1 2.9 2.9 0 01.9-2.1l-.7-.7a3.6 3.6 0 00-1.2 2.8 3.6 3.6 0 001.2 2.8l3.5 3.6a3.8 3.8 0 002.8 1.1 3.9 3.9 0 002.9-1.1zm-6.7-6.7"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-linkedin",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M16.53 8.68A3.94 3.94 0 0013 10.62V9H9.37v12h3.73v-5.95c0-1.57.29-3.09 2.24-3.09 1.95 0 1.93 1.8 1.93 3.19V21H21v-6.6c0-3.23-.69-5.72-4.47-5.72zM5.16 3a2.17 2.17 0 102.16 2.18A2.16 2.16 0 005.16 3zM3.29 9v12H7V9H3.29zm13.24-.3A3.94 3.94 0 0013 10.62V9H9.37v12h3.73v-5.95c0-1.57.29-3.09 2.24-3.09 1.95 0 1.93 1.8 1.93 3.19V21H21v-6.6c0-3.23-.69-5.72-4.47-5.72v.02zM3.29 21H7V9H3.29v12zM5.16 3a2.17 2.17 0 102.16 2.18A2.16 2.16 0 005.16 3z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-linkedin-square",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M19.67 3H4.33A1.32 1.32 0 003 4.3v15.4A1.32 1.32 0 004.33 21h15.34A1.32 1.32 0 0021 19.7V4.3A1.32 1.32 0 0019.67 3zM8.34 18.34H5.67V9.75h2.67v8.59zM7 8.57A1.55 1.55 0 118.55 7 1.54 1.54 0 017 8.57zm11.34 9.77h-2.67v-4.18c0-1 0-2.28-1.39-2.28s-1.6 1.09-1.6 2.21v4.25H10V9.75h2.56v1.17a2.83 2.83 0 012.53-1.39c2.7 0 3.2 1.78 3.2 4.1l.05 4.71z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-list",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12a.9.9 0 01-1 1 1 1 0 010-2 .9.9 0 011 1zM3 4.5a.9.9 0 00-1 1 .9.9 0 001 1 .9.9 0 001-1 .9.9 0 00-1-1zm0 13a1 1 0 000 2 1 1 0 000-2zM6 5v1h16V5zm0 7.5h16v-1H6zM6 19h16v-1H6z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-lock",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8.5H17V8A5 5 0 007 8v.5H5.5A1.5 1.5 0 004 10v8.5A1.5 1.5 0 005.5 20h13a1.5 1.5 0 001.5-1.5V10a1.5 1.5 0 00-1.5-1.5zM8 8a4 4 0 018 0v.5H8zm11 10.5a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5V10a.5.5 0 01.5-.5h13a.5.5 0 01.5.5z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.25a1 1 0 11-1 1 1 1 0 011-1m0-1a2 2 0 102 2 2 2 0 00-2-2z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-locked",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12H16V7a4 4 0 00-8 0v5h-.5a1.1 1.1 0 00-1.1 1.1v6.8A1.1 1.1 0 007.5 21h9a1.1 1.1 0 001.1-1.1v-6.8a1.1 1.1 0 00-1.1-1.1zM9 7a3 3 0 016 0v5H9zm7.6 12.9a.1.1 0 01-.1.1h-9a.1.1 0 01-.1-.1v-6.8h9.2zM13 15.5a.8.8 0 01-.5.8v1.5h-1v-1.5a.8.8 0 01-.5-.8 1 1 0 012 0z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-mail",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 5h-17A1.5 1.5 0 002 6.5v11A1.5 1.5 0 003.5 19h17a1.5 1.5 0 001.5-1.5v-11A1.5 1.5 0 0020.5 5zm-.3 1l-7.1 7.2a1.6 1.6 0 01-2.2 0L3.8 6zM3 17.3V6.6L8.3 12zm.7.7L9 12.7l1.2 1.2a2.7 2.7 0 003.6 0l1.2-1.2 5.3 5.3zm12-6L21 6.6v10.7z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-map-marker",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22L6.3 11.6c-1.7-3.1-.6-7 2.6-8.8s7.1-.6 8.8 2.5c.5 1 .8 2 .8 3.1s-.3 2.2-.8 3.1L12 22zm0-19C9 3 6.5 5.5 6.5 8.5c0 .9.2 1.9.7 2.7L12 20l4.8-8.8c1.5-2.6.5-6-2.1-7.5-.8-.5-1.8-.7-2.7-.7z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-map-marker-circle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7 5.3C16 2.2 12 1.1 8.9 2.8s-4.3 5.7-2.5 8.8L12 22l5.7-10.4c.5-1 .8-2 .8-3.1s-.3-2.2-.8-3.2zm-.9 5.8L12 19.9l-4.8-8.8c-.5-.8-.7-1.7-.7-2.7C6.5 5.4 9 3 12 3s5.5 2.5 5.5 5.5c0 .9-.2 1.8-.7 2.6z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5c-1.9 0-3.5 1.6-3.5 3.5S10.1 12 12 12s3.5-1.6 3.5-3.5S13.9 5 12 5zm0 6c-1.4 0-2.5-1.1-2.5-2.5S10.6 6 12 6s2.5 1.1 2.5 2.5S13.4 11 12 11z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-map-marker-minus",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7 5.3C16 2.2 12 1.1 8.9 2.8s-4.3 5.7-2.5 8.8L12 22l5.7-10.4c.5-1 .8-2 .8-3.1s-.3-2.2-.8-3.2zm-.9 5.8L12 19.9l-4.8-8.8c-.5-.8-.7-1.7-.7-2.7C6.5 5.4 9 3 12 3s5.5 2.5 5.5 5.5c0 .9-.2 1.8-.7 2.6z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-map-marker-plus",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 2.8c-1-.5-2-.8-3.1-.8-3.6 0-6.5 2.9-6.5 6.5 0 1.1.3 2.2.8 3.1L12 22l5.7-10.4c1.7-3.2.5-7.1-2.6-8.8zm1.7 8.3L12 19.9l-4.8-8.8c-1.5-2.7-.5-6 2.1-7.5 2.7-1.5 6-.5 7.5 2.1.5.8.7 1.7.7 2.7 0 1-.2 1.9-.7 2.7z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8h3v1h-3v3h-1V9h-3V8h3V5h1z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-maximize",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7 4l6.7 6.6-.7.7L4 4.7v3.8H3V3h5.5v1zM20 19.3l-6.6-6.7-.7.7 6.6 6.7h-3.8v1H21v-5.5h-1zM15.5 3v1h3.8l-6.6 6.6.7.7L20 4.7v3.8h1V3zM10.6 12.6L4 19.3v-3.8H3V21h5.5v-1H4.7l6.7-6.7z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-maximize-alt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 18.1l.7.7-3.8 3.9-3.9-3.9.7-.7 2.7 2.7v-7.3h1v7.3zM18.9 8.1l-.8.7 2.7 2.7h-7.3v1h7.3l-2.6 2.6.7.7 3.8-3.8zM11.5 3.2v7.3h1V3.2l2.6 2.6.7-.7L12 1.3 8.1 5.1l.7.7zM10.5 12.5v-1H3.2l2.6-2.7-.6-.7L1.3 12l3.8 3.8.7-.7-2.6-2.6z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-medium",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.63A.72.72 0 004.82 7L3.13 5v-.3h5.22l4 8.84 3.54-8.84h5V5l-1.42 1.4a.43.43 0 00-.16.4v10.12a.45.45 0 00.16.41l1.4 1.37v.3h-7v-.3l1.45-1.41c.14-.14.14-.18.14-.4V8.71L11.37 19h-.55L6.12 8.71v6.88a.93.93 0 00.26.79l1.89 2.29V19H2.91v-.3l1.89-2.32a.92.92 0 00.2-.79V7.63z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-medium-square",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3h18v18H3V3zm4.3 11.36a.64.64 0 01-.17.54l-1.27 1.54v.2h3.6v-.2L8.19 14.9a.67.67 0 01-.19-.54V9.74l3.16 6.9h.37l2.71-6.9v5.5c0 .15 0 .17-.09.27l-1 1v.2h4.74v-.2l-.89-.98a.27.27 0 01-.11-.27v-6.8a.28.28 0 01.11-.27l1-.93v-.2h-3.39L12.23 13 9.52 7.06H6v.2l1.14 1.36A.5.5 0 017.3 9v5.36z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-minimize",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15.5h5.5V21h-1v-4.5H3zM7.5 7.5H3v1h5.5V3h-1zM15.5 21h1v-4.5H21v-1h-5.5zM16.5 7.5V3h-1v5.5H21v-1z"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-minus",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.5H4v-1h16z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-minus-circle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9 11.5h10v1h-10zM22 12A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-more-actions",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10a2 2 0 102 2 2 2 0 00-2-2zm0 3a1 1 0 010-2 1 1 0 010 2zm6-3a2 2 0 102 2 2 2 0 00-2-2zm0 3a1 1 0 111-1 .9.9 0 01-1 1zm6-3a2 2 0 102 2 2 2 0 00-2-2zm0 3a1 1 0 111-1 .9.9 0 01-1 1z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-more-items",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18a1 1 0 11-1 1 .9.9 0 011-1m0-1a2 2 0 102 2 2 2 0 00-2-2zm0-6a1 1 0 11-1 1 .9.9 0 011-1m0-1a2 2 0 102 2 2 2 0 00-2-2zm0-6a.9.9 0 011 1 1 1 0 01-2 0 .9.9 0 011-1m0-1a2 2 0 102 2 2 2 0 00-2-2z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-note",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 4h-13A1.5 1.5 0 004 5.5v13A1.5 1.5 0 005.5 20h10.2l4.3-4.3V5.5A1.5 1.5 0 0018.5 4zM5 18.5v-13a.5.5 0 01.5-.5h13a.5.5 0 01.5.5V15h-2.5a1.5 1.5 0 00-1.5 1.5V19H5.5a.5.5 0 01-.5-.5zM18.3 16L16 18.3v-1.8a.5.5 0 01.5-.5zM16 9H8V8h8zm0 2H8v-1h8zm-2 1v1H8v-1z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-pa",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21h18v1H3zm0-1h18v-1H3zM22 9H2l10-7zM5.2 8h13.6L12 3.2zM6 18v-8H5v8zm4 0v-8H9v8zm5 0v-8h-1v8zm4 0v-8h-1v8z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-password-invisible",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12a3.2 3.2 0 00-.7-1.9l.4-1.1a4.2 4.2 0 011.3 3 4 4 0 01-3.9 4l.4-1.1A2.9 2.9 0 0015 12zM3.1 12A9.8 9.8 0 0112 6.5h.4l.4-.9H12a10.9 10.9 0 00-9.8 6L2 12l.2.5a11 11 0 006.1 5.3l.3-.9A9.8 9.8 0 013.1 12zm18.7-.5a11 11 0 00-6.1-5.3l-.3.9a9.8 9.8 0 015.5 4.9 9.8 9.8 0 01-8.9 5.5h-.4l-.4.9h.8a10.9 10.9 0 009.8-6l.2-.4zM11.5 9.1l.4-1.1A4 4 0 008 12a4.2 4.2 0 001.3 3l.4-1.1A3.2 3.2 0 019 12a2.9 2.9 0 012.5-2.9zm3.1-5.7L8.5 20.3l.9.3 6.1-16.9z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-password-visible",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 11.5a11 11 0 00-19.6 0L2 12l.2.5a11 11 0 0019.6 0l.2-.5zm-9.8 6A9.8 9.8 0 013.1 12 9.8 9.8 0 0112 6.5a9.8 9.8 0 018.9 5.5 9.8 9.8 0 01-8.9 5.5zM12 8a4 4 0 104 4 4 4 0 00-4-4zm0 7a3 3 0 113-3 2.9 2.9 0 01-3 3z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-pencil",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 3.5a2.9 2.9 0 00-2.1-.9 3.1 3.1 0 00-2.2.9L4.6 15.2l-1 5.2 5.2-1L20.5 7.8a3 3 0 000-4.3zm-5.7 2.8l.7-.7 2.9 2.9-.7.7zm-.7.8l1.1 1-8.4 8.4-1.1-1.1zM5.7 18.3a.7.7 0 00-.6-.3l.3-1.5 2.1 2.1-1.5.3a.7.7 0 00-.3-.6zm2.9 0l-1.1-1.1 8.4-8.4 1 1.1zM19.8 7.1l-.7.7-2.9-2.9.7-.7a2.2 2.2 0 011.5-.6 2 2 0 011.4.6 2.1 2.1 0 010 2.9z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-pin",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1 14L15 10.3V4.6L16.3 2H7.7L9 4.6v5.7L5.9 14h5.6v8h1v-8zM10 5h4v5h-4zm4.7-2l-.5 1H9.8l-.5-1zm-5 8h4.6l1.6 2H8.1z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-plug",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9.9l-2.8 2.8-1.1 1.1c-.6.6-.6 1.5 0 2.1L6 17.3l-3.8 3.9.7.7L6.7 18l1.4 1.4c.3.3.7.4 1.1.4.4 0 .8-.2 1.1-.4l1.1-1.1 2.8-2.8-5.7-5.6zm1 8.8c-.2.2-.5.2-.7 0l-3.5-3.5c-.2-.2-.2-.5 0-.7l.4-.4 4.2 4.2-.4.4zm-3.2-5.3l2.1-2.1 4.2 4.2-2.1 2.1-4.2-4.2zm9.6-8.8c-.6-.6-1.5-.6-2.1 0L11.3 7l1.4 1.4-2.1 2.1.7.7 2.1-2.1 1.4 1.4-2.1 2.1.7.7 2.1-2.1 1.5 1.4 2.5-2.5c.6-.6.6-1.5 0-2.1l-3.6-3.4zm2.8 4.9L17 11.3 12.7 7l1.8-1.8c.2-.2.5-.2.7 0l3.5 3.5c.2.3.2.6 0 .8zM8.5 12.7l.7.7-.7.7-.7-.7.7-.7zm2.8 2.8l-.7.7-.7-.7.7-.7.7.7zM18 6.7l-.7-.7 3.9-3.8.7.7L18 6.7z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-plus",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.5h-7.5V20h-1v-7.5H4v-1h7.5V4h1v7.5H20z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-plus-circle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 11.5h4.5v1h-4.5V17h-1v-4.5H6.9v-1h4.5V7h1zm9.6.5A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-presentation",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5v10.6A2.4 2.4 0 006.4 18h3.1l-1.1 4h1l1.1-4h2.7l1.2 4h1l-1.2-4h3.5a2.3 2.3 0 002.3-2.3V5zm15 10.7a1.3 1.3 0 01-1.3 1.3H6.4A1.4 1.4 0 015 15.6V6h14zM21 3v1H3V3zm-9 13a4.5 4.5 0 10-4.5-4.5A4.5 4.5 0 0012 16zm-.5-7.9V11H8.6a3.4 3.4 0 012.9-2.9zm1 3.9V8a3.5 3.5 0 01-.5 7 3.4 3.4 0 01-3.4-3z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-print",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9.5A1.5 1.5 0 0019.5 8H17V3H7v5H4.5A1.5 1.5 0 003 9.5V16h2v3h2v2h10v-2h2v-3h2zM8 4h8v4H8zM6 18v-4h1v4zm10 2H8v-6h8v6zm2-2h-1v-4h1v4zm2-3h-1v-2H5v2H4V9.5a.5.5 0 01.5-.5h15a.5.5 0 01.5.5zM6 11h4v1H6z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-refresh",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12c0 5-4 9-9 9s-9-4-9-9 4-9 9-9c2.4 0 4.7.9 6.4 2.6.4.4.8.9 1.1 1.4h-4v1H21V2.5h-1V6c-.3-.4-.6-.7-.9-1.1C15.2 1 8.8 1 4.9 4.9S1 15.2 4.9 19.1s10.2 3.9 14.1 0c1.9-1.9 2.9-4.4 2.9-7.1H21z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-restore",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C9.3 2 6.8 3 4.9 4.9c-.3.4-.6.7-.9 1.1V2.5H3V8h5.5V7h-4c.3-.5.7-.9 1.1-1.4 3.5-3.5 9.2-3.6 12.7-.1s3.6 9.2.1 12.7-9.2 3.6-12.7.1C4 16.7 3 14.4 3 12H2c0 5.5 4.5 10 10 10s10-4.5 10-10S17.5 2 12 2z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-search",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9 21.1L16 15.3a8.3 8.3 0 002-5.3 8 8 0 10-8 8 8.3 8.3 0 005.3-2l5.8 5.9zM10 17a7 7 0 117-7 7 7 0 01-7 7z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-settings",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5a4.5 4.5 0 104.5 4.5A4.5 4.5 0 0012 7.5zm0 8a3.5 3.5 0 113.5-3.5 3.5 3.5 0 01-3.5 3.5zm9.8-1.6A12.3 12.3 0 0022 12a12.3 12.3 0 00-.2-1.9l-2.1-.3a8.7 8.7 0 00-.7-1.7l1.3-1.7a8.7 8.7 0 00-2.7-2.7L15.9 5l-1.7-.7-.3-2.1L12 2l-1.9.2-.3 2.1-1.7.7-1.7-1.3a8.7 8.7 0 00-2.7 2.7L5 8.1a8.7 8.7 0 00-.7 1.7l-2.1.3A12.3 12.3 0 002 12a12.3 12.3 0 00.2 1.9l2.1.3a8.7 8.7 0 00.7 1.7l-1.3 1.7a8.7 8.7 0 002.7 2.7L8.1 19l1.7.7.3 2.1 1.9.2 1.9-.2.3-2.1 1.7-.7 1.7 1.3a8.7 8.7 0 002.7-2.7L19 15.9a8.7 8.7 0 00.7-1.7zm-2.9-.7l-.2.7a3.9 3.9 0 01-.6 1.5l-.3.6.4.5.8 1.1a9.3 9.3 0 01-1.4 1.4l-1.1-.8-.5-.4-.6.3a3.9 3.9 0 01-1.5.6l-.7.2v.7l-.2 1.3h-2l-.2-1.3v-.7l-.7-.2a3.9 3.9 0 01-1.5-.6l-.6-.3-.5.4-1.1.8A9.3 9.3 0 015 17.6l.8-1.1.4-.5-.3-.6a3.9 3.9 0 01-.6-1.5l-.2-.7h-.7L3.1 13a3.4 3.4 0 01-.1-1 3.4 3.4 0 01.1-1l1.3-.2h.7l.2-.7a3.9 3.9 0 01.6-1.5l.3-.6-.4-.5L5 6.4 6.4 5l1.1.8.5.4.6-.3a3.9 3.9 0 011.5-.6l.7-.2v-.7l.2-1.3h2l.2 1.3v.7l.7.2a3.9 3.9 0 011.5.6l.6.3.5-.4 1.1-.8A9.3 9.3 0 0119 6.4l-.8 1.1-.4.5.3.6a3.9 3.9 0 01.6 1.5l.2.7h.7l1.3.2a3.4 3.4 0 01.1 1 3.4 3.4 0 01-.1 1l-1.3.2z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-share",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15a2.5 2.5 0 00-2 1l-7.6-3.4A1.3 1.3 0 008 12a1.3 1.3 0 00-.1-.6L15.5 8a2.5 2.5 0 10-.5-1.5 1.3 1.3 0 00.1.6l-7.6 3.4a2.5 2.5 0 100 3l7.6 3.4a1.3 1.3 0 00-.1.6 2.5 2.5 0 102.5-2.5zm0-10A1.5 1.5 0 0119 6.5a1.5 1.5 0 01-3 0A1.5 1.5 0 0117.5 5zm-12 8.5a1.5 1.5 0 010-3 1.5 1.5 0 010 3zm12 5.5a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-star-full",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.7L9.5 9.2H1.6L8 13.9l-2.4 7.6 6.4-4.7 6.4 4.7-2.4-7.6 6.4-4.7h-7.9L12 1.7z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-star-outline",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.9l1.5 4.6.2.7h5.7l-4 2.9-.6.4.2.7 1.5 4.7-3.9-2.9-.6-.4-.6.4-3.9 2.9L9 14.2l.2-.7-.6-.4-4-2.9h5.7l.2-.7L12 4.9m0-3.2L9.5 9.2H1.6L8 13.9l-2.4 7.6 6.4-4.7 6.4 4.7-2.4-7.6 6.4-4.7h-7.9L12 1.7z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-team-digitale",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M23.648 24H.352A.353.353 0 010 23.648V.352C0 .158.158 0 .352 0h23.296c.194 0 .352.158.352.352v23.296a.353.353 0 01-.352.352zM5.814 11.792a1.596 1.596 0 100-3.192 1.596 1.596 0 000 3.192zM10 18.994V19h4.418C19.13 19 20 16.685 20 12.253 20 7.93 18.995 6 14.418 6H10v12.994zm4.418-10.702c2.586 0 2.838 1.11 2.838 3.955 0 2.89-.252 4.455-2.838 4.455h-1.756v-8.41h1.756z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-telephone",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3h.18M20 11.56A7.59 7.59 0 0012.48 4h-.06a.49.49 0 00-.49.48.5.5 0 00.49.51A6.61 6.61 0 0119 11.62a.51.51 0 00.54.46.49.49 0 00.45-.46s.01-.04.01-.06z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M16.93 11.68a4.5 4.5 0 00-4.48-4.48.51.51 0 000 1 3.5 3.5 0 013.49 3.49.5.5 0 00.5.5.51.51 0 00.5-.51zM15.68 21.19a13.32 13.32 0 01-12.8-13.1.92.92 0 01.62-.88c1.74-.56 4-1 4.7.06a7.39 7.39 0 01.85 2.91v.21a1.48 1.48 0 01-.7 1.68.81.81 0 00-.49.71 12.55 12.55 0 003.38 3.51.88.88 0 00.48-.56c.09-.53.58-1 1.7-.85h.21a7 7 0 012.85.87c1 .72.62 3 .09 4.72a1 1 0 01-.89.72zM6.55 7.52a9.5 9.5 0 00-2.78.55 12.41 12.41 0 0011.91 12.22c.73-2.26.66-3.54.31-3.78a6.66 6.66 0 00-2.46-.72h-.22c-.32 0-.65 0-.68.12a1.9 1.9 0 01-1.27 1.34l-.21.07-.15-.15a13.44 13.44 0 01-3.9-4L7 13a1.68 1.68 0 011-1.7c.12-.07.33-.18.25-.75v-.22a6.84 6.84 0 00-.7-2.54c-.2-.18-.55-.27-1-.27z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-tool",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 5a3.1 3.1 0 011.7.5 3.1 3.1 0 011.6 3 3 3 0 00.8 2.4l6.3 6.3a1 1 0 01.2 1.3 1 1 0 01-.8.5.9.9 0 01-.7-.3l-6.4-6.4a3 3 0 00-2.1-.8h-.6a2.8 2.8 0 01-2.2-1h2.7V6.4H5.1a2.7 2.7 0 011.1-1A2.8 2.8 0 017.7 5m0-1a4.6 4.6 0 00-2 .5 4.1 4.1 0 00-2.1 2.9h3.6v2.1H3.7a5.4 5.4 0 001 1.8 4.4 4.4 0 003 1.2h.6a2.4 2.4 0 011.4.5l6.4 6.4a2 2 0 001.4.6 1.9 1.9 0 001.6-.9 2 2 0 00-.3-2.6l-6.3-6.3a1.8 1.8 0 01-.5-1.6 4.4 4.4 0 00-2-4A4.6 4.6 0 007.7 4z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-twitter",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08 20a10.93 10.93 0 0011-11v-.5a8 8 0 001.92-2 7.85 7.85 0 01-2.22.61A3.89 3.89 0 0020.48 5a8 8 0 01-2.48.91 3.87 3.87 0 00-6.59 3.52 11 11 0 01-8-4 3.85 3.85 0 001.19 5.16 3.76 3.76 0 01-1.75-.48A3.87 3.87 0 006 13.91a3.73 3.73 0 01-1 .14 4.3 4.3 0 01-.73-.05 3.87 3.87 0 003.61 2.68 7.73 7.73 0 01-4.8 1.66 7 7 0 01-.92-.06A10.9 10.9 0 008.08 20"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-twitter-square",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 22h-15A2.5 2.5 0 012 19.5v-15A2.5 2.5 0 014.5 2h15A2.5 2.5 0 0122 4.5v15a2.5 2.5 0 01-2.5 2.5zm-9.82-4.92A7.24 7.24 0 0017 9.79v-.33a5.22 5.22 0 001.28-1.33 5.22 5.22 0 01-1.48.4 2.56 2.56 0 001.14-1.42 4.93 4.93 0 01-1.64.62 2.53 2.53 0 00-1.86-.81 2.57 2.57 0 00-2.57 2.57c.003.195.026.39.07.58a7.26 7.26 0 01-5.32-2.68 2.59 2.59 0 00.8 3.43 2.78 2.78 0 01-1.16-.32 2.57 2.57 0 002.05 2.52 2.46 2.46 0 01-1.15.04 2.55 2.55 0 002.39 1.78A5.13 5.13 0 016.37 16a6.08 6.08 0 01-.61 0 7.23 7.23 0 003.92 1.14v-.06z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-unlocked",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12H16V6a4 4 0 00-8 0v3h1V6a3 3 0 016 0v6H7.5a1.1 1.1 0 00-1.1 1.1v6.8A1.1 1.1 0 007.5 21h9a1.1 1.1 0 001.1-1.1v-6.8a1.1 1.1 0 00-1.1-1.1zm.1 7.9a.1.1 0 01-.1.1h-9a.1.1 0 01-.1-.1v-6.8h9.2zM13 15.5a.8.8 0 01-.5.8v1.5h-1v-1.5a.8.8 0 01-.5-.8 1 1 0 012 0z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-upload",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 7.3l-.7-.7L12 2.3l4.3 4.3-.7.7-3.1-3.1v9.3h-1V4.2zM19 12v7.5a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5V12H4v7.5A1.5 1.5 0 005.5 21h13a1.5 1.5 0 001.5-1.5V12z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-user",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13a4 4 0 004-4V6a4 4 0 00-8 0v3a4 4 0 004 4zM9 6a3 3 0 016 0v3a3 3 0 01-6 0zm11 16h-1a7 7 0 00-14 0H4a8 8 0 0116 0z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-video",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.3V6A1.5 1.5 0 0016 4.5H5.5A1.5 1.5 0 004 6v8a1.5 1.5 0 001.5 1.5h3.4L7.4 21h1l1.6-5.5h1.8l1.6 5.5h1l-1.6-5.5H16a1.5 1.5 0 001.5-1.5v-1.3l4 1.5V5.8zm3 5.5l-4-1.5V14a.5.5 0 01-.5.5H5.5A.5.5 0 015 14V6a.5.5 0 01.5-.5H16a.5.5 0 01.5.5v2.7l4-1.5zM2 8h1v4H2z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-warning",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17h-1V2h1zm0 3h-1v2h1z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-warning-circle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 19a9 9 0 119-9 9 9 0 01-9 9zm-.5-6.8V5.7h1.2v8.5zm-.1 2.3h1.2v1.8h-1.2z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-whatsapp",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M19.09 4.63a10 10 0 00-15.68 12L2 21.8l5.28-1.38A10 10 0 0012 21.63a10 10 0 007.05-17h.04zM12 20a8.18 8.18 0 01-4.21-1.16l-.31-.18-3.13.83.84-3.06-.19-.36A8.28 8.28 0 1112 20zm4.54-6.2c-.25-.13-1.47-.73-1.7-.81-.23-.08-.39-.13-.56.12-.246.347-.51.68-.79 1-.14.16-.29.18-.54.06a6.92 6.92 0 01-2-1.23 7.27 7.27 0 01-1.38-1.73c-.15-.25 0-.38.11-.51s.25-.29.37-.43a1.51 1.51 0 00.25-.42.46.46 0 000-.43c-.04-.2-.54-1.42-.75-1.92-.21-.5-.4-.42-.56-.43h-.47a1 1 0 00-.67.31A2.81 2.81 0 007 9.45 4.73 4.73 0 008 12a11 11 0 004.25 3.76c.464.2.938.378 1.42.53a3.28 3.28 0 001.56.09 2.54 2.54 0 001.68-1.18 2.09 2.09 0 00.15-1.2c-.06-.07-.23-.13-.48-.25l-.04.05z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-whatsapp-square",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.07a5.34 5.34 0 00-9.11 3.77 5.28 5.28 0 00.82 2.84l.12.2-.53 2 2-.53.2.11c.82.49 1.756.75 2.71.75A5.34 5.34 0 0016 8.07zm-.83 5.83a1.66 1.66 0 01-1.08.76 2.23 2.23 0 01-1-.06c-.23-.08-.53-.18-.91-.34a7.16 7.16 0 01-2.78-2.42 3.13 3.13 0 01-.66-1.66 1.83 1.83 0 01.56-1.34.59.59 0 01.43-.2H10c.1 0 .23 0 .36.27.13.27.45 1.11.49 1.19a.3.3 0 010 .28 1.2 1.2 0 01-.16.27c-.08.1-.17.21-.24.28-.07.07-.17.17-.07.33.239.413.54.787.89 1.11.38.34.816.612 1.29.8.16.08.25.06.34 0 .09-.06.4-.47.51-.63.11-.16.21-.14.36-.08.15.06.94.44 1.1.52.16.08.26.12.3.19a1.36 1.36 0 01-.03.73h.03z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M21 7.09a8.26 8.26 0 00-.09-1.15 3.49 3.49 0 00-1.85-2.51 3.89 3.89 0 00-1-.32A8.36 8.36 0 0016.91 3H7.09a8.26 8.26 0 00-1.15.09A3.49 3.49 0 003.43 5a3.89 3.89 0 00-.32 1A8.36 8.36 0 003 7.09v9.82c.003.385.033.77.09 1.15A3.49 3.49 0 005 20.57a3.89 3.89 0 001 .32c.384.06.771.094 1.16.1h9.82a8.26 8.26 0 001.15-.09 3.49 3.49 0 002.51-1.85 3.89 3.89 0 00.32-1 8.36 8.36 0 00.1-1.16V7.57c-.06-.1-.06-.31-.06-.48zm-8.8 11.17a6.39 6.39 0 01-3.06-.78l-3.41.89.92-3.32a6.33 6.33 0 01-.86-3.21 6.41 6.41 0 0111-4.53 6.33 6.33 0 011.88 4.54 6.42 6.42 0 01-6.47 6.41z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-wifi",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19h-1c0-8.8-7.2-16-16-16V2c9.4 0 17 7.6 17 17z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7v1c6.1 0 11 4.9 11 11h1c0-6.6-5.4-12-12-12zM5 12v1c3.3 0 6 2.7 6 6h1c0-3.9-3.1-7-7-7zM5 17c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 3c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-youtube",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M21.56 7.2a2.5 2.5 0 00-1.76-1.77C18.24 5 12 5 12 5s-6.24 0-7.8.42A2.5 2.5 0 002.44 7.2 25.72 25.72 0 002 12c-.01 1.61.13 3.217.42 4.8a2.5 2.5 0 001.78 1.77C5.76 19 12 19 12 19s6.24 0 7.8-.42a2.5 2.5 0 001.76-1.77A25.72 25.72 0 0022 12a25.72 25.72 0 00-.44-4.8zM10 15V9l5.19 3L10 15z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-zoom-in",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 9.5h3.3v1h-3.3v3.2h-1v-3.2H6.2v-1h3.2V6.2h1zm10.7 12.4L15.3 16a8.3 8.3 0 01-5.3 2 8 8 0 118-8 8.3 8.3 0 01-2 5.3l5.9 5.8zM17 10a7 7 0 10-7 7 7 7 0 007-7z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "it-zoom-out",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 9.5h7.5v1H6.2zm14.9 12.4L15.3 16a8.3 8.3 0 01-5.3 2 8 8 0 118-8 8.3 8.3 0 01-2 5.3l5.9 5.8zM17 10a7 7 0 10-7 7 7 7 0 007-7z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.09f15a659fcedf85b01a4d81b8a259cd.svg";
export { ForwardRef as ReactComponent };